import FetchGetDataWithAuthNEW from "../services/FetchGetDataWithAuthNEW";

export default function FechGetOneReservationLogs(club, idReservation) {

  var url = "/reservation/get_one_reservation_log/" + club + "/" + idReservation;

  return FetchGetDataWithAuthNEW(url);
}

